export default __webpack_public_path__ + "static/media/stories-image-2.bfd24c72.png";